module.exports = __webpack_public_path__ + "img/class-save.99421b3d.svg";